import { AUTH_SERVICE_URL, LOCAL_URL } from './constant';
import { PORTAL_INSTANCE } from '..';
import { DOCUMENT_ADMIN_APPROVED, DOCUMENT_ADMIN_DECLINED, DOCUMENT_CLIENT_APPROVED, DOCUMENT_CLIENT_DECLINED } from '../constants/commons';
import axios from 'axios';

const CACHE_PREFIX = '_NEXPT_'
let randLogo = Math.round(new Date().getTime() / 1000 / 60)
let lastId = 0;

export const getLanguageFromLocation = async () => {
    
    try {

        const cultureList = `${LOCAL_URL}/portalcultures/getPortalCultureList?portalId=${PORTAL_INSTANCE.pId}`
        const cultureListResponse = await axios.get(cultureList);
        let code = 'en-US'
     
        // try {
        //     const response = await axios.get('https://ipwho.is/');
        //     const countryCode = response?.data?.country_code;
        //     if (countryCode && cultureListResponse?.data?.data?.items?.length) {
        //         const culture = cultureListResponse?.data?.data?.items?.find(culture => culture?.cultureInfo?.shortCut?.toLowerCase().startsWith(countryCode?.toLowerCase()));
        //         if (culture) {
        //             code = culture.cultureInfo.shortCut;
        //         }
        //     }
        // } catch (error1) {
        //     console.log("Error getting location:", error1);
        // }
        
        return {
            code,
            cultureList: cultureListResponse?.data?.data?.items
        };
    } catch (error) {
        console.log("Error getting culture list:", error);
        return {
            code: 'en-US',
            cultureList: []
        };
    }
}


export default function getLastId() {
    lastId++;
    return `${lastId}`;
}
export const portalLogoUrl = (isNewRanNum = false) => {
    const { pId: portalId } = PORTAL_INSTANCE
    if (isNewRanNum) {
        randLogo = Math.round(new Date().getTime() / 1000 / 60)
    }
    return `${AUTH_SERVICE_URL}/portal/logo/${portalId}/plogo_${portalId}.png?r=${randLogo}`;
}

export const getPortalBackgroundUrl = (isNewRanNum = false) => {
    const { pId: portalId } = PORTAL_INSTANCE
    if (isNewRanNum) {
        randLogo = Math.round(new Date().getTime() / 1000 / 60)
    }
    return `${AUTH_SERVICE_URL}/portal/background/${portalId}?r=${randLogo}`;
}
export function base64EncodeUnicode(str) {
    if (typeof str != 'string') {
        str = JSON.stringify(str);
    }
    // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
    // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
    let utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function (match, p1) {
            return String.fromCharCode(parseInt("0x" + p1));
        }
    );

    return window.btoa(utf8Bytes);
}
export function base64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''));
}

export class Storage {
    constructor() {
        this.storage = {};
    }
    setItem(key, data) {
        this.storage[key] = data;
    }

    getItem(key) {
        return this.storage[key];
    }

    removeItem(key) {
        delete this.storage[key];
    }
}


const ckey = (key) => {
    return `${CACHE_PREFIX}_${key}`
}

export class CacheService {
    constructor() {
        this.isSupported = this.isCheckSupported();
        this.inMemoryStorage = new Storage()
    }
    isCheckSupported() {
        try {
            const testKey = "__wqwqfwghjuitoy8675653243140707dgdnmkrye__";
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }

    getStorage() {
        return this.isSupported ? localStorage : this.inMemoryStorage;
    }

    // 6 hours = 6 * 3600000 = 21600000 milliseconds
    setCache(key, p, expireTime = 21600000) {
        // expireTime: time in milliseconds
        // Set expireTime to null or 0 for no expiration
        const cacheData = {
            data: p,
            expireAt: (expireTime && expireTime > 0) ? Date.now() + expireTime : null
        }
        this.getStorage().setItem(ckey(key), base64EncodeUnicode(JSON.stringify(cacheData)))
    }

    removeCache(key) {
        this.getStorage().removeItem(ckey(key))
    }

    getCache(key) {
        // console.log('getCache', key)
        let json = null
        try {
            let val = this.getStorage().getItem(ckey(key))
            //console.log('getCache', key, val)
            if (!val) {
                return json
            }
            const parsed = JSON.parse(base64DecodeUnicode(val))
            
            // Check if cache has expire time structure (new format)
            if (parsed && typeof parsed === 'object' && 'data' in parsed && 'expireAt' in parsed) {
                // New format with expire time
                if (parsed.expireAt && Date.now() > parsed.expireAt) {
                    // Cache expired, remove it and return null
                    this.removeCache(key)
                    return null
                }
                // Cache still valid, return data
                json = parsed.data
            } else {
                // Old format (cache without expire time) - remove old cache
                this.removeCache(key)
                return null
            }
        } catch (e) {
            console.log('Error getCache', e)
        }
        return json
    }
}

export const cacheService = new CacheService();

export const getLang = (portalId = 0, defaultLocale = 'en-US') => {
    return cacheService.getCache(`lang_${portalId}`) || defaultLocale
}
export const setLang = (portalId = 0, locale = 'en-US') => {
    return cacheService.setCache(`lang_${portalId}`, locale)
}
export const hasLang = (portalId = 0) => {
    return cacheService.getCache(`lang_${portalId}`) ? true : false
}

export const isObjectEmpty = (obj) => {
    return (
        obj &&
        Object.keys(obj).length === 0 &&
        obj.constructor === Object
    );
};

export const getPurgedObject = (obj) => {
    let objString = JSON.stringify(obj, (_, value) => {
        return ['', null].includes(value) || (typeof value === 'object' && (value.length === 0 || Object.keys(value).length === 0)) ? undefined : value;
    });
    let result = JSON.parse(objString);
    let hasEmptyProps = ['{}', '[]', '""', 'null'].some((key) => objString.includes(key))
    if (hasEmptyProps) {
        return getPurgedObject(result);
    }
    return result;
}

export const camelCase = (inputString) => {
    const words = inputString.replace(/-/g, '').split(' ');
    const camelCaseString = words.reduce((result, word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        const camelCasedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        return result + camelCasedWord;
    }, '');
    return camelCaseString;
}

export const upperFirstChar = (str) => {
    return str?.length ? str.split(" ").map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ") : '';
}

export const toCapitalize = (str) => {
    return str.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};

export const getBackLabelColor = (doc) => {
    if (!doc?.statusId) {
        return "#f2e9fd"
    }
    if (doc.statusId === DOCUMENT_CLIENT_APPROVED || doc.statusId === DOCUMENT_ADMIN_APPROVED) {
        return "#B9EDD2"
    }
    if (doc.statusId === DOCUMENT_CLIENT_DECLINED || doc.statusId === DOCUMENT_ADMIN_DECLINED) {
        return "#ffa0b1"
    }
    return "#f2e9fd"
}